<div class="relative w-full group">
  <!-- Glowing background aura -->
  <div
    class="absolute -inset-0.5 rounded-xl animated-glow opacity-25 blur-md group-hover:opacity-50 transition duration-500"
  ></div>

  <!-- Main gradient button link -->
  <a
    [routerLink]="routerLink()"
    class="relative flex items-center justify-center gap-2.5 w-full py-3 px-4 rounded-xl animated-gradient text-white font-extrabold shadow-md hover:shadow-lg active:scale-[0.96] transition-all duration-200 select-none cursor-pointer overflow-hidden border border-white/10"
  >
    @if (icon()) {
      <mat-icon [svgIcon]="icon()" class="size-5 text-white" />
    }
    <span class="text-sm uppercase tracking-wider text-white text-shadow">{{ label() }}</span>

    <!-- Shimmering sweep effect -->
    <div class="absolute inset-0 w-full h-full overflow-hidden pointer-events-none">
      <div class="shimmer-effect"></div>
    </div>
  </a>
</div>
